import { Payload } from '../types'

export const genRequestFormDefaultValues = (payloadState: Payload) => ({
  relationshipType: payloadState.relationshipType,
  accountType: payloadState.accountType,
  requestType: payloadState.requestType,
  onBehalf: payloadState.onBehalf
})

export const genAgentFormDefaultValues = (payloadState: Payload) => ({
  deliveryMethod: payloadState.deliveryMethod,
  firstName: payloadState.agentFirstName,
  middleName: payloadState.agentMiddleName,
  lastName: payloadState.agentLastName,
  suffix: payloadState.agentSuffix,
  email: payloadState.agentEmail,
  phone: payloadState.agentPhoneNumber ? payloadState.agentPhoneNumber : '',
  dob: payloadState.agentDateOfBirth,
  addressLine1: payloadState.agentStreetAddress,
  addressLine2: payloadState.agentAddressLine2,
  city: payloadState.agentCity,
  state: payloadState.agentState,
  zip: payloadState.agentZip
})

export const genConsumerDefaultValues = (payloadState: Payload) => ({
  deliveryMethod: payloadState.deliveryMethod,
  firstName: payloadState.consumerFirstName,
  middleName: payloadState.consumerMiddleName,
  lastName: payloadState.consumerLastName,
  suffix: payloadState.consumerSuffix,
  email: payloadState.consumerEmail,
  phone: payloadState.consumerPhoneNumber ? payloadState.consumerPhoneNumber : '',
  accountNumber: payloadState.consumerAccountNumber,
  dob: payloadState.consumerDateOfBirth,
  addressLine1: payloadState.consumerStreetAddress,
  addressLine2: payloadState.consumerAddressLine2,
  city: payloadState.consumerCity,
  state: payloadState.consumerState,
  zip: payloadState.consumerZip
})

